import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "55",
  height: "55",
  viewBox: "0 0 55 55",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M46.817 15.009 35.73 3.854l-1.183-.473H8.452l-1.69 1.69v18.59h3.38v-16.9h20.281v11.83l1.69 1.69h11.83v3.38h3.38v-7.436l-.506-1.216Zm-13.014 1.893V6.76l10.14 10.14h-10.14ZM8.452 27.042l-1.69 1.69v20.281l1.69 1.69h37.182l1.69-1.69v-20.28l-1.69-1.69H8.452Zm35.492 16.901v3.38H10.142v-16.9h33.802v13.52Zm-27.042-3.38h-1.081v3.38h-2.299v-10.14h3.583c2.535 0 3.82 1.216 3.82 3.38a3.177 3.177 0 0 1-1.082 2.433 4.496 4.496 0 0 1-2.94.947Zm-.203-4.901h-.878v3.143h.878c1.217 0 1.826-.54 1.826-1.588s-.609-1.555-1.826-1.555Zm13.724 6.861a5.001 5.001 0 0 0 1.487-3.786c0-3.38-1.791-4.934-5.408-4.934h-3.583v10.14h3.583a5.409 5.409 0 0 0 3.921-1.42Zm-5.24-.44v-6.421H26.3a3.177 3.177 0 0 1 2.366.845 3.076 3.076 0 0 1 .845 2.264 3.38 3.38 0 0 1-.845 2.434 3.178 3.178 0 0 1-2.332.879h-1.15Zm15.042-2.061h-3.278v3.921h-2.299v-10.14h5.882v1.859h-3.583v2.5h3.278v1.86Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }